import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MessageCircle, ArrowLeft } from "lucide-react";
import Navbar from "../Landing/Navbar";
import Footer from "../Components/Footer";

const WHATSAPP_NUMBER = "919912349925";
const WHATSAPP_MESSAGE = "Hi Karanki Matrimony, I need help with my account.";

const ContactUs = () => {
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <main className="page-container max-w-3xl pt-4 pb-app-nav sm:pt-7 lg:pt-10">
        <Link
          to="/"
          className="inline-flex min-h-9 items-center gap-1.5 rounded-full border border-sand-200 bg-white px-3.5 text-[12px] font-semibold text-ink-600 transition hover:border-brand-200 hover:text-brand-700"
        >
          <ArrowLeft size={14} /> Back to home
        </Link>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="mt-8 max-w-xl sm:mt-12"
        >
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#E9F9EF] text-[#168A4A]">
            <MessageCircle size={22} />
          </div>

          <p className="mt-5 text-[10px] font-semibold uppercase tracking-[0.16em] text-brand-700">
            Karanki Matrimony support
          </p>
          <h1 className="mt-1 font-display text-[28px] font-bold leading-tight text-ink-800 sm:text-3xl">
            How can we help?
          </h1>
          <p className="mt-2 max-w-lg text-[13px] leading-6 text-ink-500 sm:text-[14px]">
            Have a question about your account or need help using Karanki Matrimony? Send our support team a message on WhatsApp.
          </p>

          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6 inline-flex min-h-12 w-full max-w-sm items-center justify-center gap-2.5 rounded-xl bg-[#168A4A] px-5 text-[13px] font-semibold text-white transition hover:bg-[#11763F] active:scale-[0.99]"
          >
            <svg
              viewBox="0 0 24 24"
              fill="currentColor"
              className="h-5 w-5"
              aria-hidden="true"
            >
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
            </svg>
            Message support on WhatsApp
          </a>
          <p className="mt-3 text-[11px] text-ink-400">
            WhatsApp will open in a new window.
          </p>
        </motion.div>
      </main>

      <Footer />
    </div>
  );
};

export default ContactUs;
